import { CampaignActionsCarrosselController } from './campaign-actions-carrossel.controller'

function campaignActionsCarrossel () {
  return {
    restrict: 'E',
    scope: {},
    templateUrl: '/arts/directives/campaign-actions-carrossel/campaign-actions-carrossel.html?$$REVISION$$',
    controller: CampaignActionsCarrosselController
  }
}

export { campaignActionsCarrossel }
